// extracted by mini-css-extract-plugin
export default {"flex":"global_flex__NpEgl","alignCenter":"global_alignCenter__R9dpp","justifyCenter":"global_justifyCenter__T9LsJ","center":"global_center__RYNZf","row":"global_row__V71Y6"};